<template>
  <div class="index">
    <table border class="index-table">
      <tr>
        <td class="index-table-label">家长姓名</td>
        <td>张三达</td>

        <td class="index-table-label">会员姓名</td>
        <td>刘大大</td>
      </tr>
      <tr>
        <td class="index-table-label">手机号</td>
        <td>11111111111</td>
        <td class="index-table-label">孩子性别</td>
        <td>男</td>
      </tr>
    </table>
    <div class="index-steps">
      <el-steps direction="vertical">
        <el-step>
          <img
            class="index-steps-icon"
            slot="icon"
            src="@/assets/icons/xa.png"
            alt=""
          />
          <div slot="description">
            <p>跟进时间：2022-03-03 跟进人：张三</p>
            <p>跟进内容：这里是跟进内容</p>
            <p>客户跟进</p>
          </div>
        </el-step>
        <el-step>
          <img
            class="index-steps-icon"
            slot="icon"
            src="@/assets/icons/xb.png"
            alt=""
          />
          <div slot="description">
            <p>跟进时间：2022-03-03 跟进人：张三 安排人：张思</p>
            <p>跟进内容：这里是跟进内容</p>
            <p>客户跟进</p>
          </div>
        </el-step>
        <el-step>
          <img
            class="index-steps-icon"
            slot="icon"
            src="@/assets/icons/xb.png"
            alt=""
          />
          <div slot="description">
            <p>跟进时间：2022-03-03 跟进人：张三</p>
            <p>跟进内容：这里是跟进内容</p>
            <p>客户跟进</p>
          </div>
        </el-step>
        <el-step>
          <img
            class="index-steps-icon"
            slot="icon"
            src="@/assets/icons/xb.png"
            alt=""
          />
          <div slot="description">
            <p>跟进时间：2022-03-03 跟进人：张三 安排人：张思</p>
            <p>跟进内容：这里是跟进内容</p>
            <p>客户跟进</p>
          </div>
        </el-step>
        <el-step>
          <img
            class="index-steps-icon"
            slot="icon"
            src="@/assets/icons/xb.png"
            alt=""
          />
          <div slot="description">
            <p>跟进时间：2022-03-03 操作人：张三</p>
            <p>跟进内容：这里是跟进内容</p>
            <p>客户跟进</p>
          </div>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.index {
  &-table {
    width: 100%;
    border-collapse: collapse;
    border-color: #e4e1e1;
    tr {
      td {
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
    &-label {
      background-color: #e9e1e1;
    }
  }
  &-steps {
    margin-top: 20px;
    /deep/ .el-step__description {
      color: #333333;
    }
    /deep/ .el-step__line {
      background: #b6b3b3;
    }
    &-icon {
      width: 25px;
      height: 25px;
    }
    /deep/ .el-step__icon.is-text {
      border: none;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff;
  }
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
</style>



// WEBPACK FOOTER //
// src/views/user/components/step.vue